var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYellowStatusIcon = function SvgYellowStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EDBB1D",
    cx: 11,
    cy: 11,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }))));
};

export default SvgYellowStatusIcon;